export const forBusiness_jewelry_showcase = [
	{
		icon: '🔹',
		subtitle: 'showcaseData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'showcaseData_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'showcaseData_subtitle3',
	},
];
